import React, { useState } from "react";
import SubHeader from "components/SubHeader";
import { ROUTES } from "shared/constants/routes";
import { SHEET_SIZES, SHEET_WIDTH_IN } from "pages/dtf-transfers/gang-sheet/data";
import { getSheetUnitPrice } from "pages/dtf-transfers/gang-sheet/helpers";
import ProductHeader from "pages/dtf-transfers/gang-sheet/ProductHeader";
import ProductGallery from "pages/dtf-transfers/gang-sheet/ProductGallery";
import SheetSizePicker from "pages/dtf-transfers/gang-sheet/SheetSizePicker";
import GangSheetBuilder from "pages/dtf-transfers/gang-sheet/GangSheetBuilder";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import {
  Container,
  PageCard,
  PageLayout,
  GalleryColumn,
  ContentColumn,
  CreateButton,
} from "styles/pages/dtf-transfers/gang-sheet";

const DtfGangSheetBuilderPage = () => {
  const defaultSize = SHEET_SIZES[0];
  const [sheetWidth, setSheetWidth] = useState(defaultSize.width || SHEET_WIDTH_IN);
  const [sheetHeight, setSheetHeight] = useState(defaultSize.height);
  const [builderOpen, setBuilderOpen] = useState(false);

  return (
    <Container>
      <SubHeader
        title={ROUTES.DTF_TRANSFERS_GANG_SHEET.TITLE}
        links={[
          {
            title: ROUTES.HOME.TITLE,
            to: ROUTES.HOME.LINK,
          },
          {
            title: ROUTES.DTF_TRANSFERS.TITLE,
            to: ROUTES.DTF_TRANSFERS_BY_SIZE.LINK,
          },
        ]}
        currentPageTitle={ROUTES.DTF_TRANSFERS_GANG_SHEET.TITLE}
      />

      <PageCard>
        <PageLayout>
          <GalleryColumn>
            <ProductGallery />
          </GalleryColumn>

          <ContentColumn>
            <ProductHeader sheetWidth={sheetWidth} sheetHeight={sheetHeight} />
            <SheetSizePicker
              sheetWidth={sheetWidth}
              sheetHeight={sheetHeight}
              onChange={({ sheetWidth: nextWidth, sheetHeight: nextHeight }) => {
                setSheetWidth(nextWidth);
                setSheetHeight(nextHeight);
              }}
            />
            <div style={{ marginTop: 24 }}>
              <CreateButton onClick={() => setBuilderOpen(true)}>
                <AutoAwesomeIcon style={{ fontSize: "20px" }} />
                Create a Gang Sheet
              </CreateButton>
            </div>
          </ContentColumn>
        </PageLayout>
      </PageCard>

      <Dialog
        open={builderOpen}
        onClose={() => setBuilderOpen(false)}
        fullScreen
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 24px",
            borderBottom: "1px solid #e5e7eb",
            backgroundColor: "#f8fafc",
            fontFamily: "Inter600",
            fontSize: "20px",
            color: "#1e293b",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <span style={{ fontSize: "16px", color: "#64748b", fontFamily: "Inter500" }}>Sheet Size:</span>
            <select
              value={`${sheetWidth}x${sheetHeight}`}
              onChange={(e) => {
                const selected = SHEET_SIZES.find((s) => s.id === e.target.value);
                if (selected) {
                  setSheetWidth(selected.width);
                  setSheetHeight(selected.height);
                }
              }}
              style={{
                padding: "6px 12px",
                borderRadius: "6px",
                border: "1px solid #cbd5e1",
                fontFamily: "Inter600",
                fontSize: "15px",
                color: "#1e293b",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                outline: "none",
              }}
            >
              {SHEET_SIZES.map((size) => {
                const price = getSheetUnitPrice(size.width, size.height);
                return (
                  <option key={size.id} value={size.id}>
                    {size.width}" × {size.height}" — ${price.toFixed(2)}
                  </option>
                );
              })}
            </select>
          </div>
          <IconButton onClick={() => setBuilderOpen(false)} size="large">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: "24px", backgroundColor: "#f8fafc" }}>
          <GangSheetBuilder
            key={`create-${sheetWidth}x${sheetHeight}`}
            sheetWidth={sheetWidth}
            sheetHeight={sheetHeight}
            onClose={() => setBuilderOpen(false)}
          />
        </DialogContent>
      </Dialog>
    </Container>
  );
};

export default DtfGangSheetBuilderPage;
